// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-list .survey-group {
	margin-bottom: 20px;
	border-bottom: solid 1px var(--mdh-border-color-1);
}

.survey-list .survey-group .survey-group-title {
	padding-left: 0px;
	text-transform: uppercase;
	font-size: 14px;
	color: var(--mdh-text-color-2);
	padding-bottom: 8px;
	padding-top: 16px;
	padding-left: 16px;
}

.survey-list .survey {
	background: var(--mdh-background-color-0);
	border-top: solid 1px var(--mdh-border-color-1);
	padding: 12px 8px 12px 58px;
	position: relative;
	cursor: pointer;
}

.survey-list .survey:hover {
	background: var(--mdh-background-color-2);
}

.survey-list .survey .survey-title {
	font-size: 17px;
}

.survey-list .survey .survey-description {
	font-size: 15px;
	color: var(--mdh-text-color-2);
}

.survey-list .survey .due-indicator {
	position: absolute;
	height: 100%;
	background: #45d24f;
	left: 0;
	top: 0;
	width: 8px;
}

.survey-list .survey.overdue .due-indicator {
	background: #bf0022;
}

.survey-list .survey.due-today .due-indicator {
	background: #fbef46;
}

.survey-list .survey .completion-check {
	position: absolute;
	left: 16px;
	height: 30px;
	font-size: 30px;
	top: 50%;
	color: var(--mdh-text-color-2);
}

.survey-list .survey .completion-check .fa {
	position: absolute;
	top: -15px;
	left: 0;
	width: 30px;
	text-align: center;
}

.survey-list .blocked {
	opacity: .5;
	cursor: default;
}

.survey-list .blocked:hover {
	background: var(--mdh-background-color-0);
}

.survey-list .no-surveys {
	padding: 32px 16px 32px 16px;
	font-size: 16px;
}

@media (max-width: 680px) {
	.survey-list .survey .completion-check .fa {
		width: auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/SurveyList.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,kDAAkD;AACnD;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,8BAA8B;CAC9B,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,+CAA+C;CAC/C,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,OAAO;CACP,MAAM;CACN,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,eAAe;CACf,QAAQ;CACR,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,OAAO;CACP,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;CACC;EACC,WAAW;CACZ;AACD","sourcesContent":[".survey-list .survey-group {\n\tmargin-bottom: 20px;\n\tborder-bottom: solid 1px var(--mdh-border-color-1);\n}\n\n.survey-list .survey-group .survey-group-title {\n\tpadding-left: 0px;\n\ttext-transform: uppercase;\n\tfont-size: 14px;\n\tcolor: var(--mdh-text-color-2);\n\tpadding-bottom: 8px;\n\tpadding-top: 16px;\n\tpadding-left: 16px;\n}\n\n.survey-list .survey {\n\tbackground: var(--mdh-background-color-0);\n\tborder-top: solid 1px var(--mdh-border-color-1);\n\tpadding: 12px 8px 12px 58px;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.survey-list .survey:hover {\n\tbackground: var(--mdh-background-color-2);\n}\n\n.survey-list .survey .survey-title {\n\tfont-size: 17px;\n}\n\n.survey-list .survey .survey-description {\n\tfont-size: 15px;\n\tcolor: var(--mdh-text-color-2);\n}\n\n.survey-list .survey .due-indicator {\n\tposition: absolute;\n\theight: 100%;\n\tbackground: #45d24f;\n\tleft: 0;\n\ttop: 0;\n\twidth: 8px;\n}\n\n.survey-list .survey.overdue .due-indicator {\n\tbackground: #bf0022;\n}\n\n.survey-list .survey.due-today .due-indicator {\n\tbackground: #fbef46;\n}\n\n.survey-list .survey .completion-check {\n\tposition: absolute;\n\tleft: 16px;\n\theight: 30px;\n\tfont-size: 30px;\n\ttop: 50%;\n\tcolor: var(--mdh-text-color-2);\n}\n\n.survey-list .survey .completion-check .fa {\n\tposition: absolute;\n\ttop: -15px;\n\tleft: 0;\n\twidth: 30px;\n\ttext-align: center;\n}\n\n.survey-list .blocked {\n\topacity: .5;\n\tcursor: default;\n}\n\n.survey-list .blocked:hover {\n\tbackground: var(--mdh-background-color-0);\n}\n\n.survey-list .no-surveys {\n\tpadding: 32px 16px 32px 16px;\n\tfont-size: 16px;\n}\n\n@media (max-width: 680px) {\n\t.survey-list .survey .completion-check .fa {\n\t\twidth: auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
